/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'limited-supply': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10 19a3 3 0 013 3v7a3 3 0 01-3 3H3a3 3 0 01-3-3v-7a3 3 0 013-3h7zm19 0a3 3 0 013 3v7a3 3 0 01-3 3h-7a3 3 0 01-3-3v-7a3 3 0 013-3h7zM10 0a3 3 0 013 3v7a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h7z" _fill="#FF9D08" fill-rule="evenodd"/>'
  }
})
